var indexOf = [].indexOf;

import humanize from 'helpers/humanize';

import {
  SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS
} from 'react/types/sms_settings';

import featureNames from 'constants/feature_names';

angular.module('gym.sequences').controller('EditSequenceCtrl', ["$scope", "$state", "$filter", "$rootScope", "$modal", "$http", "$document", "$timeout", "flash", "Sequences", "TaskTypes", "SequenceCategories", "Workouts", "Templates", "SequenceService", "EmploymentService", "TemplateValidationService", "SmsValidationService", "PushNotificationValidationService", "GTMService", "ActivityService", "FeatureNamesService", "FeatureAvailabilityService", "MembershipPlans", "ProspectForms", "GradingStyles", "ConfirmLeaveUnsavedChangesService", "PushNotificationOptionsService", "Waivers", "isInteger", "sequence", "templates", "reports", function($scope, $state, $filter, $rootScope, $modal, $http, $document, $timeout, flash, Sequences, TaskTypes, SequenceCategories, Workouts, Templates, SequenceService, EmploymentService, TemplateValidationService, SmsValidationService, PushNotificationValidationService, GTMService, ActivityService, FeatureNamesService, FeatureAvailabilityService, MembershipPlans, ProspectForms, GradingStyles, ConfirmLeaveUnsavedChangesService, PushNotificationOptionsService, Waivers, isInteger, sequence, templates, reports) {
  var contactFlagPayloadInvalid, contactNotePayloadInvalid, containsBookingCancellationMergeTags, containsBookingMergeTags, containsGradingMergeTags, containsLateBookingCancellationMergeTags, containsMembershipMergeTags, containsPaymentMergeTags, containsPerformedWorkoutMergeTags, containsRecurringBookingMergeTags, containsStyleMergeTags, containsSuspensionMergeTags, containsWaitlistAttendeeMergeTags, creditVoucherPayloadInvalid, formFieldUpdatePayloadInvalid, getCreditVoucherCategories, getEmailOverrides, getPayloadFailureAction, getProspectStatuses, gym, hasPushNotificationSteps, hasValidationErrors, isPushNotificationValid, isSmsValid, loadForms, loadMembershipPlans, loadSequenceCategories, loadStyles, loadTaskTypes, loadWaivers, loadWorkouts, makeupClassPayloadInvalid, params, pushRoutesLoaded, pushRoutesLoading, ref, removePageLeaveListeners, save, scrollToStep, sequenceContainsBookingCancellationMergeTags, sequenceContainsBookingMergeTags, sequenceContainsGradingMergeTags, sequenceContainsLateBookingCancellationMergeTags, sequenceContainsMembershipMergeTags, sequenceContainsPaymentMergeTags, sequenceContainsPerformedWorkoutMergeTags, sequenceContainsRecurringBookingMergeTags, sequenceContainsStyleMergeTags, sequenceContainsSuspensionMergeTags, sequenceContainsWaitlistAttendeeMergeTags, taskPayloadInvalid, toDraggable, waiverPayloadInvalid;
  $scope.gym = gym = $rootScope.gym;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.manage_sequences) {
    $state.go('gym.dashboard');
  }
  $scope.smsOptOutInstructionsOptions = SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS;
  $scope.memberPortalLabel = FeatureNamesService.memberPortal();
  $scope.users = $rootScope.gym.users;
  $scope.waiversEnabled = (ref = gym.gym_waiver_detail) != null ? ref.enabled : void 0;
  $scope.currency = gym.currency_symbol;
  $scope.usesCreditVouchers = FeatureAvailabilityService.isAvailable('credit_vouchers');
  $scope.templates = [];
  $scope.featureNames = featureNames;
  $scope.sequence = sequence.plain();
  $scope.reports = reports.plain();
  $scope.triggers = SequenceService.getTriggers(sequence);
  $scope.pushNotificationRoutes = [
    {
      label: "No preference (open app to Notifications list)",
      value: ''
    }
  ];
  $scope.findSmsOptionLabelByValue = function(value) {
    var option;
    option = SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS.find(function(opt) {
      return opt.value === value;
    });
    if (option) {
      return option.label;
    } else {
      return null;
    }
  };
  removePageLeaveListeners = ConfirmLeaveUnsavedChangesService.watch($scope, 'sequence');
  $scope.dragParams = {
    isDragging: false,
    mouseDown: false
  };
  $scope.dayWeekMonthUnits = [['day', 'days'], ['week', 'weeks'], ['month', 'months']];
  $scope.getPlanPurchaseLimitLabel = function(plan) {
    if (plan.purchase_limit && plan.purchases_remaining === 0) {
      return `${plan.label} (Sold out)`;
    } else if (plan.purchase_limit && plan.purchases_remaining > 0) {
      return `${plan.label} (${plan.purchases_remaining} remaining)`;
    } else {
      return plan.label;
    }
  };
  getPayloadFailureAction = function() {
    var sendEmail, sequencePayloadFailurePolicy;
    sequencePayloadFailurePolicy = sequence.payload_failure_policy || $scope.gym.gym_sequence_detail.payload_failure_policy;
    sendEmail = sequence.send_email_on_payload_failure || $scope.gym.gym_sequence_detail.send_email_on_payload_failure;
    if (sendEmail) {
      if (sequencePayloadFailurePolicy === 'pause_sequence_on_payload_failure') {
        return 'pause_and_send_email';
      } else if (sequencePayloadFailurePolicy === 'stop_sequence_on_payload_failure') {
        return 'stop_and_send_email';
      } else {
        return 'skip_and_send_email';
      }
    } else {
      if (sequencePayloadFailurePolicy === 'pause_sequence_on_payload_failure') {
        return 'pause_and_do_not_send_email';
      } else if (sequencePayloadFailurePolicy === 'stop_sequence_on_payload_failure') {
        return 'stop_and_do_not_send_email';
      } else {
        return 'skip_and_do_not_send_email';
      }
    }
  };
  $scope.pageParams = {
    payloadFailureAction: getPayloadFailureAction(),
    selectedFormSection: {
      id: 0,
      label: 'All forms',
      fields: []
    }
  };
  $scope.payloadFailureOptions = [
    {
      label: `Pause the ${featureNames.SEQUENCE_LOWERCASE} (do not send alert email)`,
      value: 'pause_and_do_not_send_email'
    },
    {
      label: `Pause the ${featureNames.SEQUENCE_LOWERCASE} and send an alert email`,
      value: 'pause_and_send_email'
    },
    {
      label: `Stop the ${featureNames.SEQUENCE_LOWERCASE} (do not send alert email)`,
      value: 'stop_and_do_not_send_email'
    },
    {
      label: `Stop the ${featureNames.SEQUENCE_LOWERCASE} and send an alert email`,
      value: 'stop_and_send_email'
    },
    {
      label: 'Skip to next step (do not send alert email)',
      value: 'skip_and_do_not_send_email'
    },
    {
      label: 'Skip to next step and send an alert email',
      value: 'skip_and_send_email'
    }
  ];
  $scope.onPayloadFailureActionChange = function() {
    var ref1, ref2, ref3;
    $scope.sequence.send_email_on_payload_failure = (ref1 = $scope.pageParams.payloadFailureAction) === 'pause_and_send_email' || ref1 === 'skip_and_send_email' || ref1 === 'stop_and_send_email';
    return $scope.sequence.payload_failure_policy = (ref2 = $scope.pageParams.payloadFailureAction) === 'pause_and_send_email' || ref2 === 'pause_and_do_not_send_email' ? 'pause_sequence_on_payload_failure' : (ref3 = $scope.pageParams.payloadFailureAction) === 'stop_and_send_email' || ref3 === 'stop_and_do_not_send_email' ? 'stop_sequence_on_payload_failure' : 'skip_step_on_payload_failure';
  };
  $scope.onPayloadFailureActionChange();
  getEmailOverrides = function() {
    return $http.get(`gyms/${gym.id}/email_overrides`, {
      params: {
        count: 1000
      }
    }).then(function(response) {
      var ref1;
      $scope.emailOverrides = (ref1 = response.data) != null ? ref1.collection : void 0;
      return $scope.sequenceFailureDigestDisabled = !!_.find($scope.emailOverrides, function(item) {
        return item.email_type === 'sequence_payload_failure_digest' && item.do_not_send;
      });
    });
  };
  getEmailOverrides();
  toDraggable = function(items) {
    return items.map(function(item) {
      return [item];
    });
  };
  loadTaskTypes = function() {
    return TaskTypes.getList().then(function(taskTypes) {
      $scope.taskTypes = taskTypes.map(function(item) {
        item.type = 'task';
        return item;
      });
      return $scope.draggableTaskTypes = toDraggable($scope.taskTypes);
    });
  };
  loadTaskTypes();
  loadMembershipPlans = function() {
    return MembershipPlans.getList({
      count: 1000
    }).then(function(membershipPlans) {
      $scope.membershipPlans = membershipPlans.map(function(item) {
        item.template_type = 'membership';
        return item;
      });
      $scope.draggableMembershipPlans = toDraggable($scope.membershipPlans);
      return $scope.membershipPlanCategories = _.chain($scope.membershipPlans).groupBy((item) => {
        var ref1;
        return ((ref1 = item.category) != null ? ref1.label : void 0) || 'No category';
      }).pairs().map(function(item) {
        return item[0];
      }).sortBy(function(item) {
        if (item === 'No category') {
          return '';
        } else {
          return item;
        }
      }).value();
    });
  };
  loadMembershipPlans();
  loadWorkouts = function() {
    if (!gym.workouts_enabled) {
      return;
    }
    return Workouts.all('workouts').getList({
      count: 1000
    }).then(function(workouts) {
      $scope.workouts = workouts.map(function(item) {
        item.type = 'workout';
        return item;
      });
      return $scope.draggableWorkouts = toDraggable($scope.workouts);
    });
  };
  loadWorkouts();
  loadSequenceCategories = function() {
    if (!$scope.sequenceCategories) {
      $scope.sequenceCategories = [];
    }
    return SequenceCategories.getList({
      count: 1000
    }).then(function(sequenceCategories) {
      return $scope.sequenceCategories = sequenceCategories;
    });
  };
  loadSequenceCategories();
  $scope.manageCategories = function() {
    var manageCategoryModal;
    manageCategoryModal = $modal.open({
      template: require('templates/gyms/sequences/sequence_categories_modal.html.slim'),
      controller: 'ManageSequenceCategoriesModalCtrl'
    });
    return manageCategoryModal.result.then(function() {
      return loadSequenceCategories();
    }, function() {
      return loadSequenceCategories();
    });
  };
  loadStyles = function() {
    if (!$scope.gym.is_martial_arts) {
      return;
    }
    return GradingStyles.getList({
      count: 1000
    }).then(function(styles) {
      $scope.styles = styles.map(function(item) {
        item.type = 'style';
        return item;
      });
      return $scope.draggableStyles = toDraggable($scope.styles);
    });
  };
  loadStyles();
  loadForms = function() {
    var url;
    $scope.formsSections = [
      {
        id: 0,
        label: 'All forms',
        fields: []
      }
    ];
    url = `/gyms/${gym.id}/forms/sequence_payload_forms`;
    return $http.get(url).then(function(response) {
      var formsSections;
      formsSections = response.data.map(function(section) {
        var availableFields;
        availableFields = section.fields.filter(function(field) {
          var ref1, ref2;
          if (field.type === 'drop_select' && !((ref1 = field.params) != null ? (ref2 = ref1.options) != null ? ref2.length : void 0 : void 0)) {
            return false;
          }
          return field.custom_field_payload_enabled;
        });
        section.fields = availableFields.map(function(field) {
          field.field_type = field.type;
          field.type = 'form_field_update';
          return field;
        });
        return section;
      }).filter(function(section) {
        return section.fields.length;
      });
      $scope.formsSections = $scope.formsSections.concat(formsSections);
      $scope.formFields = _.flatten(_.pluck($scope.formsSections, 'fields'));
      return $scope.onFormSectionSelect();
    });
  };
  loadForms();
  $scope.onFormSectionSelect = function() {
    if (!$scope.pageParams.selectedFormSection) {
      return;
    }
    if ($scope.pageParams.selectedFormSection.id === 0) {
      return $scope.draggableFormFields = toDraggable($scope.formFields);
    } else {
      return $scope.draggableFormFields = toDraggable($scope.pageParams.selectedFormSection.fields);
    }
  };
  $scope.displayFieldType = function(type) {
    switch (type) {
      case 'drop_select':
        return 'Dropdown';
      default:
        return humanize(type);
    }
  };
  $scope.mobileAppEnabled = function() {
    var ref1;
    return $scope.gym.mobile_app_enabled && ((ref1 = $rootScope.mobileAppMeta) != null ? ref1.push_notifications_feature_enabled : void 0);
  };
  $scope.portalActions = toDraggable([
    {
      title: 'Enable member portal access',
      type: 'portal',
      enabled: true
    },
    {
      title: 'Disable member portal access',
      type: 'portal',
      enabled: false
    }
  ]);
  $scope.draggableMakeupClassActions = toDraggable([
    {
      title: 'Add make-up class',
      type: 'makeup_class'
    }
  ]);
  $scope.draggableConvertToNacActions = toDraggable([
    {
      title: 'Convert to Non-Attending Contact',
      type: 'convert_to_nac'
    }
  ]);
  $scope.draggableContactFlagActions = toDraggable([
    {
      title: 'Add flag to contact',
      type: 'contact_flag'
    }
  ]);
  $scope.draggableAccessControlActions = toDraggable([
    {
      title: 'Add Brivo Credential to contact',
      type: 'access_control'
    }
  ]);
  $scope.draggableNoteActions = toDraggable([
    {
      title: 'Add note to contact',
      type: 'note'
    }
  ]);
  if ($scope.gym.mobile_app_enabled) {
    params = {
      'filters[role]': 'mobile_app_invite_prompt'
    };
    Templates.getList(params).then(function(response) {
      var mobileAppInviteEmailTemplate, mobileAppInviteSmsTemplate;
      mobileAppInviteEmailTemplate = _.find(response.plain(), function(item) {
        return item.channel === 'email';
      });
      mobileAppInviteSmsTemplate = _.find(response.plain(), function(item) {
        return item.channel === 'sms';
      });
      return $scope.mobileAppActions = toDraggable([
        {
          title: 'Enable mobile app access',
          type: 'mobile_app',
          enabled: true
        },
        {
          title: 'Disable mobile app access',
          type: 'mobile_app',
          enabled: false
        },
        {
          title: 'Send mobile app invite (email)',
          type: 'mobile_app',
          send_mobile_app_invite: true,
          subject: mobileAppInviteEmailTemplate != null ? mobileAppInviteEmailTemplate.subject : void 0,
          body: mobileAppInviteEmailTemplate != null ? mobileAppInviteEmailTemplate.content : void 0
        },
        {
          title: 'Send mobile app invite (SMS)',
          type: 'mobile_app',
          send_mobile_app_invite_sms: true,
          body: mobileAppInviteSmsTemplate != null ? mobileAppInviteSmsTemplate.content : void 0
        }
      ]);
    });
  }
  $scope.emailUserActions = [
    [
      {
        name: 'Blank template',
        subtitle: 'Create a new email from scratch',
        type: 'email_user'
      }
    ]
  ];
  $scope.onMouseDown = function() {
    return $scope.dragParams.mouseDown = true;
  };
  $scope.onMouseMove = function() {
    if ($scope.dragParams.mouseDown) {
      return $scope.dragParams.isDragging = true;
    }
  };
  $scope.onMouseUp = function() {
    return $timeout(function() {
      $scope.dragParams.mouseDown = false;
      return $scope.dragParams.isDragging = false;
    });
  };
  $scope.showTemplate = function(template) {
    if ($scope.dragParams.isDragging) {
      return;
    }
    if (!template.id) {
      return;
    }
    return $modal.open({
      template: require('templates/gyms/communication_templates/show_template.html.slim'),
      controller: 'ShowTemplateCtrl',
      resolve: {
        template: function() {
          return template;
        }
      }
    });
  };
  $scope.selectTemplate = function(template, e) {
    var collection;
    e.stopPropagation();
    collection = $scope.sequence.sequence_steps_attributes;
    SequenceService.addSequenceStep(template, collection.length, collection, $scope.sequence);
    return $timeout(function() {
      var items;
      items = angular.element('.sequence-item--last');
      if (items.length) {
        return $document.scrollToElementAnimated(items[items.length - 1], 100);
      }
    }, 50);
  };
  $scope.manageTaskTypes = function() {
    var eventModal;
    eventModal = $modal.open({
      template: require('templates/gyms/tasks/taskTypes.html.slim'),
      controller: 'TaskTypesCtrl',
      resolve: {
        taskTypes: function() {
          return $scope.taskTypes;
        }
      }
    });
    return eventModal.result.then(function() {
      return loadTaskTypes();
    });
  };
  getProspectStatuses = function() {
    var ref1;
    if ((ref1 = $scope.prospectStatuses) != null ? ref1.length : void 0) {
      return;
    }
    return ProspectForms.getList().then(function(data) {
      var field, form, ref2;
      form = _.find(data, function(form) {
        return form.name === 'contact_information';
      });
      if (!form) {
        return;
      }
      field = _.find(form.fields, function(f) {
        return f.name === 'prospect_status';
      });
      return $scope.prospectStatuses = (ref2 = field.params) != null ? ref2.options.map(function(status) {
        return [
          {
            title: `Set status to: ${status}`,
            type: 'prospect_status',
            status: status
          }
        ];
      }) : void 0;
    });
  };
  loadWaivers = function() {
    var ref1;
    if ((ref1 = $scope.waivers) != null ? ref1.length : void 0) {
      return;
    }
    return Waivers.getList({
      count: 1000
    }).then(function(response) {
      var waivers;
      waivers = response.plain().filter(function(item) {
        return !item.draft;
      });
      $scope.waivers = waivers.map(function(item) {
        item.type = 'waiver';
        return item;
      });
      return $scope.draggableWaivers = toDraggable($scope.waivers);
    });
  };
  loadWaivers();
  getCreditVoucherCategories = function() {
    var ref1, url;
    if ((ref1 = $scope.creditVoucherCategories) != null ? ref1.length : void 0) {
      return;
    }
    url = `/gyms/${gym.id}/credit_voucher_categories?count=1000`;
    return $http.get(url).then(function(response) {
      $scope.creditVoucherCategories = response.data.collection.map(function(category) {
        category.title = `Add a ${category.name} credit voucher`;
        category.type = 'credit_voucher';
        return category;
      });
      return $scope.draggableCreditVoucherCategories = toDraggable($scope.creditVoucherCategories);
    });
  };
  getCreditVoucherCategories();
  $scope.setTemplatesType = function(type) {
    $scope.templatesType = type;
    if (type === 'email' || type === 'sms' || type === 'push_notification') {
      $scope.templates = toDraggable(SequenceService.getTemplatesByType(templates, type));
      $scope.categories = _.chain($scope.templates).groupBy((item) => {
        return item[0].category_name || 'No category';
      }).pairs().map(function(item) {
        return item[0];
      }).sortBy(function(item) {
        if (item === 'No category') {
          return '';
        } else {
          return item;
        }
      }).value();
    }
    if (type === 'prospect_status') {
      return getProspectStatuses();
    }
  };
  $scope.templatesByCategory = function(ary) {
    var item;
    item = ary[0];
    if ($scope.categories.lenth < 2 || !$scope.pageParams.selectedTemplatesCategory) {
      return true;
    }
    if (!item.category_name && $scope.pageParams.selectedTemplatesCategory === 'No category') {
      return true;
    }
    return item.category_name === $scope.pageParams.selectedTemplatesCategory;
  };
  $scope.membershipPlansByCategory = function(ary) {
    var item, ref1, ref2;
    item = ary[0];
    if ($scope.membershipPlanCategories.lenth < 2 || !$scope.pageParams.selectedMembershipPlanCategory) {
      return true;
    }
    if (!((ref1 = item.category) != null ? ref1.label : void 0) && $scope.pageParams.selectedMembershipPlanCategory === 'No category') {
      return true;
    }
    return ((ref2 = item.category) != null ? ref2.label : void 0) === $scope.pageParams.selectedMembershipPlanCategory;
  };
  $scope.onTriggerChanged = function() {
    return SequenceService.onTriggerChanged($scope.sequence);
  };
  if (!$scope.gym.custom_emails_enabled && !$scope.sequence.id) {
    $scope.setTemplatesType('task');
  } else {
    $scope.setTemplatesType('email');
  }
  $scope.getSequenceItemClass = function(index, last) {
    return {
      'sequence-item--last': last,
      [`sequence-item--${index}`]: true
    };
  };
  $scope.draggableTemplatesParams = {
    connectWith: '.connected-drop-target-sortable',
    update: function(e, ui) {
      var collection, data, index, model;
      data = angular.extend({}, ui.item.sortable);
      collection = $scope.sequence.sequence_steps_attributes;
      model = data.model;
      index = data.dropindex > collection.length ? collection.length : data.dropindex;
      ui.item.sortable.cancel();
      return SequenceService.addSequenceStep(model, index, collection, $scope.sequence);
    }
  };
  $scope.sortableSequenceStepsOptions = {
    delay: 120,
    tolerance: 'pointer',
    placeholder: "sequence-item sequence-item--empty",
    cancel: 'input,textarea,button,select,option,.template-editor',
    update: function(e, ui) {
      var fromIndex, toIndex;
      fromIndex = ui.item.sortable.index;
      toIndex = ui.item.sortable.dropindex;
      if (!($scope.isReorderAllowed(fromIndex, toIndex))) {
        return ui.item.sortable.cancel();
      }
    },
    end: function() {
      return SequenceService.recalculatePositions($scope.sequence.sequence_steps_attributes, $scope.sequence);
    }
  };
  $scope.isTaskStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.task_type_id;
    });
  };
  $scope.isSendMobileAppInviteEmailStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'MobileAppSequencePayload' && payload.send_mobile_app_invite;
    });
  };
  $scope.isSendMobileAppInviteSmsStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'MobileAppSequencePayload' && payload.send_mobile_app_invite_sms;
    });
  };
  $scope.isMessageStep = function(step) {
    return $scope.isSendMobileAppInviteEmailStep(step) || $scope.isSendMobileAppInviteSmsStep(step) || !!_.find(step.sequence_payloads_attributes, function(payload) {
      var ref1;
      return (ref1 = payload.type) === 'EmailSequencePayload' || ref1 === 'SmsSequencePayload' || ref1 === 'EmailUserSequencePayload' || ref1 === 'PushNotificationSequencePayload';
    });
  };
  $scope.isPortalStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'MemberPortalSequencePayload';
    });
  };
  $scope.isMobileAppStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'MobileAppSequencePayload' && !payload.send_mobile_app_invite && !payload.send_mobile_app_invite_sms;
    });
  };
  $scope.isMembershipStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'NewMembershipSequencePayload';
    });
  };
  $scope.isWorkoutStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'ContactWorkoutSequencePayload';
    });
  };
  $scope.isStyleStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'NewMemberStyleSequencePayload';
    });
  };
  $scope.isCreditVoucherStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'AddCreditVoucherSequencePayload';
    });
  };
  $scope.isMakeupClassStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'AddMakeupClassSequencePayload';
    });
  };
  $scope.isContactFlagStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'AddContactFlagSequencePayload';
    });
  };
  $scope.isFormFieldUpdateStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'FormFieldUpdateSequencePayload';
    });
  };
  $scope.isProspectStatusStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'ProspectStatusChangeSequencePayload';
    });
  };
  $scope.isWaiverStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'SendWaiverSequencePayload';
    });
  };
  $scope.isConvertToNacStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'ConvertToNacSequencePayload';
    });
  };
  $scope.isAccessControlStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'AddBrivoCredentialSequencePayload';
    });
  };
  $scope.isNoteStep = function(step) {
    return !!_.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'AddNoteSequencePayload';
    });
  };
  $scope.getMembershipPlan = function(step) {
    return _.find($scope.membershipPlans, function(plan) {
      return plan.id === step.sequence_payloads_attributes[0].membership_plan_id;
    });
  };
  $scope.getWorkout = function(step) {
    return _.find($scope.workouts, function(plan) {
      return plan.id === step.sequence_payloads_attributes[0].workout_id;
    });
  };
  $scope.getWorkoutPayload = function(step) {
    return step.sequence_payloads_attributes[0];
  };
  $scope.getStyle = function(step) {
    return _.find($scope.styles, function(style) {
      return style.id === step.sequence_payloads_attributes[0].style_id;
    });
  };
  $scope.getWaiver = function(step) {
    return _.find($scope.waivers, function(waiver) {
      return waiver.id === step.sequence_payloads_attributes[0].waiver_id;
    });
  };
  $scope.portalStepValue = function(step) {
    var payload;
    payload = _.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'MemberPortalSequencePayload';
    });
    return payload.member_portal_enabled;
  };
  $scope.mobileAppStepValue = function(step) {
    var payload;
    payload = _.find(step.sequence_payloads_attributes, function(payload) {
      return payload.type === 'MobileAppSequencePayload';
    });
    return payload.mobile_app_enabled;
  };
  $scope.moveStep = function(model, from, to) {
    return SequenceService.moveStep(model, from, to, $scope.sequence.sequence_steps_attributes, $scope.sequence);
  };
  $scope.isReorderAllowed = function(from, to) {
    if (!$scope.sequence.can_reorder_steps) {
      return false;
    }
    if (to + 1 > SequenceService.presentStepsCount($scope.sequence)) {
      return false;
    }
    if (SequenceService.isForseeable($scope.sequence) || !$scope.sequence.id) {
      return from > 0 && to > 0;
    } else {
      return from > 1 && to > 1;
    }
  };
  $scope.updatePayload = function(payload, stepIndex) {
    return $scope.sequence.sequence_steps_attributes[stepIndex].sequence_payloads_attributes[0] = payload;
  };
  $scope.editPayload = function(sequenceStep) {
    SequenceService.sanitizePayloadAttributes($scope.sequence);
    return sequenceStep.sequence_payloads_attributes[0].editable = true;
  };
  $scope.isEmailPayload = function(sequenceStep) {
    var ref1;
    return ((ref1 = sequenceStep.sequence_payloads_attributes[0]) != null ? ref1.type : void 0) === 'EmailSequencePayload';
  };
  $scope.isSmsPayload = function(sequenceStep) {
    var ref1;
    return ((ref1 = sequenceStep.sequence_payloads_attributes[0]) != null ? ref1.type : void 0) === 'SmsSequencePayload';
  };
  $scope.isEmailUserPayload = function(sequenceStep) {
    var ref1;
    return ((ref1 = sequenceStep.sequence_payloads_attributes[0]) != null ? ref1.type : void 0) === 'EmailUserSequencePayload';
  };
  $scope.isPushNotificationPayload = function(sequenceStep) {
    var ref1;
    return ((ref1 = sequenceStep.sequence_payloads_attributes[0]) != null ? ref1.type : void 0) === 'PushNotificationSequencePayload';
  };
  $scope.getPayloadUserEmail = function(payload) {
    var user;
    user = _.find($scope.users, function(item) {
      return item.id === payload.user_id;
    });
    return user != null ? user.email : void 0;
  };
  $scope.payloadTypeClass = function(sequenceStep) {
    var ref1, type;
    type = (ref1 = sequenceStep.sequence_payloads_attributes[0]) != null ? ref1.type : void 0;
    return ActivityService.payloadTypeClass(type);
  };
  $scope.isStepVisible = function(step) {
    if (!!step._destroy) {
      return;
    }
    return step.position !== 1 || !$scope.sequence.trigger || SequenceService.isForseeable($scope.sequence);
  };
  $scope.isStepRemoveAllowed = function(step) {
    return !$scope.sequence.trigger || (SequenceService.isForseeable($scope.sequence) && step.position > 1) || (!SequenceService.isForseeable($scope.sequence) && step.position > 2);
  };
  $scope.isTriggerConditionExists = function(step) {
    return SequenceService.isTriggerConditionExists(step);
  };
  $scope.isTimeConditionExists = function(step) {
    return SequenceService.isTimeConditionExists(step);
  };
  $scope.isForseeable = function() {
    return SequenceService.isForseeable($scope.sequence);
  };
  $scope.isFollowable = function() {
    return SequenceService.isFollowable($scope.sequence);
  };
  $scope.isFloatingFollowable = function() {
    return SequenceService.isFloatingFollowable($scope.sequence);
  };
  $scope.isMakeupClassTrigger = function() {
    var ref1;
    return ref1 = $scope.sequence.trigger, indexOf.call($scope.sequence.makeup_class_triggers, ref1) >= 0;
  };
  $scope.isSequencePeriodDisplaying = function(step) {
    if (!SequenceService.isTimeConditionExists(step)) {
      return;
    }
    if ($scope.sequence.trigger && !SequenceService.isForseeable($scope.sequence)) {
      return step.position > 2;
    } else {
      return step.position > 1;
    }
  };
  $scope.getSequencePeriod = function(step) {
    var condition, period, term, unit;
    condition = SequenceService.isTimeConditionExists(step);
    period = condition.time_since_previous_step || 0;
    unit = condition.time_since_previous_step_unit;
    term = $filter('pluralize')(unit, period, true);
    return `After ${term}`;
  };
  $scope.removeStep = function(step) {
    if (step.id) {
      step._destroy = 1;
      return SequenceService.recalculatePositions($scope.sequence.sequence_steps_attributes);
    } else {
      return $scope.sequence.sequence_steps_attributes = _.reject($scope.sequence.sequence_steps_attributes, function(sequenceStep) {
        return sequenceStep.position === step.position;
      });
    }
  };
  $scope.cancel = function() {
    return $state.go('gym.sequences.list');
  };
  sequenceContainsBookingMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsBookingMergeTags);
    });
  };
  sequenceContainsMembershipMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsMembershipMergeTags);
    });
  };
  sequenceContainsPaymentMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsPaymentMergeTags);
    });
  };
  sequenceContainsGradingMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsGradingMergeTags);
    });
  };
  sequenceContainsStyleMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsStyleMergeTags);
    });
  };
  sequenceContainsSuspensionMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsSuspensionMergeTags);
    });
  };
  sequenceContainsRecurringBookingMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsRecurringBookingMergeTags);
    });
  };
  sequenceContainsLateBookingCancellationMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsLateBookingCancellationMergeTags);
    });
  };
  sequenceContainsBookingCancellationMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsBookingCancellationMergeTags);
    });
  };
  sequenceContainsWaitlistAttendeeMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsWaitlistAttendeeMergeTags);
    });
  };
  sequenceContainsPerformedWorkoutMergeTags = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, containsPerformedWorkoutMergeTags);
    });
  };
  containsBookingMergeTags = function(template) {
    return TemplateValidationService.containsBookingMergeTags(template);
  };
  containsPaymentMergeTags = function(template) {
    return TemplateValidationService.containsPaymentMergeTags(template);
  };
  containsMembershipMergeTags = function(template) {
    return TemplateValidationService.containsMembershipMergeTags(template);
  };
  containsGradingMergeTags = function(template) {
    return TemplateValidationService.containsGradingMergeTags(template);
  };
  containsStyleMergeTags = function(template) {
    return TemplateValidationService.containsStyleMergeTags(template);
  };
  containsSuspensionMergeTags = function(template) {
    return TemplateValidationService.containsSuspensionMergeTags(template);
  };
  containsRecurringBookingMergeTags = function(template) {
    return TemplateValidationService.containsRecurringBookingMergeTags(template);
  };
  containsLateBookingCancellationMergeTags = function(template) {
    return TemplateValidationService.containsLateBookingCancellationMergeTags(template);
  };
  containsBookingCancellationMergeTags = function(template) {
    return TemplateValidationService.containsBookingCancellationMergeTags(template);
  };
  containsWaitlistAttendeeMergeTags = function(template) {
    return TemplateValidationService.containsWaitlistAttendeeMergeTags(template);
  };
  containsPerformedWorkoutMergeTags = function(template) {
    return TemplateValidationService.containsPerformedWorkoutMergeTags(template);
  };
  $scope.isPaymentSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'invoice') >= 0;
  };
  $scope.isPaymentRelatedSequence = function() {
    var ref1, triggers;
    triggers = ['credit_card_expiry'];
    return $scope.isPaymentSequence() || ($scope.sequence.trigger && (ref1 = $scope.sequence.trigger, indexOf.call(triggers, ref1) >= 0));
  };
  $scope.isMembershipSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'membership') >= 0;
  };
  $scope.isBookingSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'booking') >= 0;
  };
  $scope.isStyleSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'member_style') >= 0;
  };
  $scope.isGradingSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'member_grading') >= 0;
  };
  $scope.isSuspensionSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'contact_suspension') >= 0;
  };
  $scope.isRecurringBookingSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'recurring_booking_detail') >= 0;
  };
  $scope.isLateBookingCancellationSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'late_booking_cancellation') >= 0;
  };
  $scope.isBookingCancellationSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'booking_cancellation') >= 0;
  };
  $scope.isWaitlistAttendeeSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'waitlist_attendee') >= 0;
  };
  $scope.isPerformedWorkoutSequence = function() {
    return $scope.sequence.trigger && indexOf.call($scope.sequence.sequence_object_map[$scope.sequence.trigger], 'performed_workout') >= 0;
  };
  $scope.pushNotificationRoutesContext = function() {
    if ($scope.isPaymentSequence()) {
      return 'payment_sequence';
    } else if ($scope.isBookingSequence()) {
      return 'booking_sequence';
    } else if ($scope.isMembershipSequence()) {
      return 'membership_sequence';
    } else if ($scope.isPerformedWorkoutSequence()) {
      return 'workout_sequence';
    } else {
      return '';
    }
  };
  hasPushNotificationSteps = function() {
    return _.find($scope.sequence.sequence_steps_attributes, function(step) {
      return !step._destroy && _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'PushNotificationSequencePayload';
      });
    });
  };
  pushRoutesLoading = false;
  pushRoutesLoaded = false;
  $scope.loadPushNotificationRoutes = function() {
    if (!$scope.mobileAppEnabled()) {
      return;
    }
    if (!hasPushNotificationSteps()) {
      return;
    }
    if (pushRoutesLoading || pushRoutesLoaded) {
      return;
    }
    pushRoutesLoading = true;
    return PushNotificationOptionsService.getOptions($scope.gym.id, $scope.pushNotificationRoutesContext()).then(function(data) {
      if (data.length) {
        $scope.pushNotificationRoutes = [
          {
            label: "No preference (open app to Notifications list)",
            value: ''
          }
        ].concat(data);
      } else {
        $scope.pushNotificationRoutes = data;
      }
      return pushRoutesLoaded = true;
    }).catch(function(error) {
      return flash.error(error);
    }).finally(function() {
      return pushRoutesLoading = false;
    });
  };
  $scope.loadPushNotificationRoutes();
  $scope.$watch('sequence.trigger', function(newTrigger, oldTrigger) {
    if (newTrigger !== oldTrigger && oldTrigger !== void 0) {
      pushRoutesLoaded = false;
      return $scope.loadPushNotificationRoutes();
    }
  });
  $scope.$watch('sequence.sequence_steps_attributes', function() {
    if (hasPushNotificationSteps() && !pushRoutesLoaded && !pushRoutesLoading) {
      return $scope.loadPushNotificationRoutes();
    }
  }, true);
  $scope.findNotificationRouteLabelByValue = function(value) {
    var option;
    option = $scope.pushNotificationRoutes.find(function(opt) {
      return opt.value === value;
    });
    if (option) {
      return option.label;
    } else {
      return 'No preference (open app to Notifications list)';
    }
  };
  $scope.displayWaiverType = function(type) {
    switch (type) {
      case 'member':
        return 'Member';
      case 'prospect':
        return 'Prospect';
      case 'non_attending_contact':
        return 'Non-attending Contact';
    }
  };
  $scope.displayWaiverAllowSigningBy = function(allow_signing_by) {
    switch (allow_signing_by) {
      case 'both':
        return 'All contacts';
      case 'adult_with_family':
        return 'Parents w/ dependants only';
      case 'adult':
        return 'Individuals only';
    }
  };
  $scope.humanizedRecipientChoice = function(value) {
    var sendToMatchingRecipientsLabel;
    sendToMatchingRecipientsLabel = (function() {
      switch (false) {
        case !$scope.isBookingSequence():
          return 'Recipients that accept booking messages';
        case !$scope.isPaymentRelatedSequence():
          return 'Recipients that accept payment messages';
        default:
          return `Recipients that accept messages sent from ${featureNames.SEQUENCE_PLURAL_LOWERCASE}`;
      }
    })();
    switch (value) {
      case 'send_to_contact_only':
        return 'This contact only';
      case 'send_to_matching_recipients':
        return sendToMatchingRecipientsLabel;
      case 'send_to_matching_recipients_with_contact_fallback':
        return `${sendToMatchingRecipientsLabel} (or: send to contact if no other recipients available)`;
    }
  };
  $scope.recipientChoiceTooltip = function(value) {
    var sendToMatchingRecipientsLabel;
    sendToMatchingRecipientsLabel = (function() {
      switch (false) {
        case !$scope.isBookingSequence():
          return "Message will be sent to all recipients defined on the contact's profile page that accept booking-related messages.";
        case !$scope.isPaymentRelatedSequence():
          return "Message will be sent to all recipients defined on the contact's profile page that accept payment-related messages.";
        default:
          return `Message will be sent to all recipients defined on the contact's profile page that accept messages triggered from general ${featureNames.SEQUENCE_PLURAL_LOWERCASE}.`;
      }
    })();
    switch (value) {
      case 'send_to_contact_only':
        return `Message will be sent to the contact enrolled in the ${featureNames.SEQUENCE_LOWERCASE}.`;
      case 'send_to_matching_recipients':
        return `${sendToMatchingRecipientsLabel} If no such recipients are found, the message will not be sent.`;
      case 'send_to_matching_recipients_with_contact_fallback':
        return `${sendToMatchingRecipientsLabel} If no such recipients are found, the message will be sent to the contact.`;
    }
  };
  $scope.today = moment(gym.today).toDate();
  $scope.onStepExpiryTypeChange = function(step, type) {
    switch (type) {
      case 'date':
        if (!step.expires_on) {
          step.expires_on = gym.today;
          step.expires_on_relative_number = void 0;
          return step.expires_on_relative_unit = void 0;
        }
        break;
      case 'relative':
        if (!step.expires_on_relative_unit) {
          step.expires_on = void 0;
          return step.expires_on_relative_unit = 'day';
        }
        break;
      default:
        step.expires_on = void 0;
        step.expires_on_relative_number = void 0;
        return step.expires_on_relative_unit = void 0;
    }
  };
  $scope.onCreditVoucherAmountChange = function(payload) {
    return payload.amount_cents = payload.amount ? payload.amount * 100 : 0;
  };
  $scope.initCreditVoucherAmount = function(payload) {
    return payload.amount = payload.amount_cents ? payload.amount_cents / 100 : 0;
  };
  $scope.isTemplateValid = function(template) {
    return !(!$scope.isPaymentSequence() && containsPaymentMergeTags(template)) && !(!$scope.isMembershipSequence() && containsMembershipMergeTags(template)) && !(!$scope.isBookingSequence() && containsBookingMergeTags(template)) && !(!$scope.isStyleSequence() && containsStyleMergeTags(template)) && !(!$scope.isGradingSequence() && containsGradingMergeTags(template)) && !(!$scope.isSuspensionSequence() && containsSuspensionMergeTags(template)) && !(!$scope.isRecurringBookingSequence() && containsRecurringBookingMergeTags(template)) && !(!$scope.isLateBookingCancellationSequence() && containsLateBookingCancellationMergeTags(template)) && !(!$scope.isBookingCancellationSequence() && containsBookingCancellationMergeTags(template)) && !(!$scope.isWaitlistAttendeeSequence() && containsWaitlistAttendeeMergeTags(template)) && !(!$scope.isPerformedWorkoutSequence() && containsPerformedWorkoutMergeTags(template));
  };
  isSmsValid = function() {
    return !_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(message) {
        var smsError, template;
        template = {
          channel: message.type === 'SmsSequencePayload' && 'sms',
          content: message.body
        };
        smsError = SmsValidationService.getErrors(template);
        return message.type === 'SmsSequencePayload' && (!SmsValidationService.isLengthValid(message.body) || smsError);
      });
    });
  };
  isPushNotificationValid = function() {
    return !_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(message) {
        return message.type === 'PushNotificationSequencePayload' && (!PushNotificationValidationService.isLengthValid(message.body));
      });
    });
  };
  $scope.isValid = function() {
    var ref1;
    return !(!$scope.isPaymentSequence() && sequenceContainsPaymentMergeTags()) && !(!$scope.isMembershipSequence() && sequenceContainsMembershipMergeTags()) && !(!$scope.isBookingSequence() && sequenceContainsBookingMergeTags()) && !(!$scope.isStyleSequence() && sequenceContainsStyleMergeTags()) && !(!$scope.isGradingSequence() && sequenceContainsGradingMergeTags()) && !(!$scope.isSuspensionSequence() && sequenceContainsSuspensionMergeTags()) && !(!$scope.isRecurringBookingSequence() && sequenceContainsRecurringBookingMergeTags()) && !(!$scope.isLateBookingCancellationSequence() && sequenceContainsLateBookingCancellationMergeTags()) && !(!$scope.isBookingCancellationSequence() && sequenceContainsBookingCancellationMergeTags()) && !(!$scope.isWaitlistAttendeeSequence() && sequenceContainsWaitlistAttendeeMergeTags()) && !(!$scope.isPerformedWorkoutSequence() && sequenceContainsPerformedWorkoutMergeTags()) && isSmsValid() && isPushNotificationValid() && !$scope.isLoading && ((ref1 = $scope.formFields) != null ? ref1.length : void 0);
  };
  save = function(enabled) {
    $scope.sequence.enabled = enabled ? true : void 0;
    if (sequence.id) {
      $scope.sequence.rootObjectName = 'sequence';
      return Sequences.doPUT($scope.sequence, `${$scope.sequence.id}`);
    } else {
      return Sequences.post($scope.sequence);
    }
  };
  scrollToStep = function(index) {
    return $timeout(function() {
      var items;
      items = angular.element(`.sequence-item--${index}`);
      if (items.length) {
        return $document.scrollToElementAnimated(items[0], 100);
      }
    }, 50);
  };
  taskPayloadInvalid = function() {
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'TaskSequencePayload' && payload.dueDateEnabled && (!isInteger(payload.due_date_day_delta) || payload.due_date_day_delta < 0);
      });
    });
  };
  creditVoucherPayloadInvalid = function() {
    var hasInvalidParams;
    hasInvalidParams = function(payload) {
      var ref1;
      return !(payload.amount_cents >= 1) || !((ref1 = payload.credit_voucher_description) != null ? ref1.trim() : void 0) || (payload.expires_on_relative_unit && !(payload.expires_on_relative_number >= 1));
    };
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'AddCreditVoucherSequencePayload' && hasInvalidParams(payload);
      });
    });
  };
  makeupClassPayloadInvalid = function() {
    var hasInvalidParams;
    hasInvalidParams = function(payload) {
      return !$scope.isMakeupClassTrigger() || !(payload.number_of_allowances >= 1) || (payload.expires_on_relative_unit && !(payload.expires_on_relative_number >= 1));
    };
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'AddMakeupClassSequencePayload' && hasInvalidParams(payload);
      });
    });
  };
  contactFlagPayloadInvalid = function() {
    var hasInvalidParams;
    hasInvalidParams = function(payload) {
      var ref1;
      return !((ref1 = payload.flag_description) != null ? ref1.trim().length : void 0);
    };
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'AddContactFlagSequencePayload' && hasInvalidParams(payload);
      });
    });
  };
  contactNotePayloadInvalid = function() {
    var hasInvalidParams;
    hasInvalidParams = function(payload) {
      var ref1, ref2;
      return !((ref1 = payload.note_subject) != null ? ref1.trim().length : void 0) || !((ref2 = payload.note_body) != null ? ref2.trim().length : void 0);
    };
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'AddNoteSequencePayload' && hasInvalidParams(payload);
      });
    });
  };
  formFieldUpdatePayloadInvalid = function() {
    var hasInvalidParams;
    hasInvalidParams = function(payload) {
      var field, ref1;
      field = $scope.formFields.find(function(item) {
        return item.id === payload.form_field_id;
      });
      return !field || ((field != null ? field.required : void 0) && ((ref1 = payload.form_field_value) === (void 0) || ref1 === null || ref1 === '')) || (payload.use_relative_custom_date && !(payload.relative_custom_date_number === 0 || payload.relative_custom_date_number > 0));
    };
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step, index) {
      var isInvalid;
      if (step._destroy) {
        return;
      }
      isInvalid = _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'FormFieldUpdateSequencePayload' && hasInvalidParams(payload);
      });
      if (isInvalid) {
        scrollToStep(index);
      }
      return isInvalid;
    });
  };
  waiverPayloadInvalid = function() {
    return !!_.find($scope.sequence.sequence_steps_attributes, function(step) {
      return _.find(step.sequence_payloads_attributes, function(payload) {
        return payload.type === 'SendWaiverSequencePayload' && !payload.waiver_child_choice;
      });
    });
  };
  hasValidationErrors = function() {
    return taskPayloadInvalid() || waiverPayloadInvalid() || creditVoucherPayloadInvalid() || makeupClassPayloadInvalid() || contactFlagPayloadInvalid() || formFieldUpdatePayloadInvalid() || contactNotePayloadInvalid();
  };
  $scope.save = function(enabled) {
    var trackPage;
    trackPage = sequence.id ? 'Sequences - Edit' : 'Sequences - New';
    GTMService.trackPage(trackPage, 'attempt');
    if (hasValidationErrors()) {
      flash.error = 'Please fix the errors below';
      return $scope.displayValidationErrors = true;
    } else {
      SequenceService.sanitizePayloadAttributes($scope.sequence);
      $scope.isLoading = true;
      return save(enabled).then(function(data) {
        removePageLeaveListeners();
        GTMService.trackPage(trackPage, 'success');
        return $state.go('gym.sequences.list');
      }, function(response) {
        $scope.isLoading = false;
        GTMService.trackPage(trackPage, 'error');
        flash.error = 'Save failed. Please fix the errors below';
        $scope.sequence.errors = response.data.errors;
        if (enabled) {
          return $scope.sequence.enabled = void 0;
        }
      });
    }
  };
  $scope.getMessageErrors = function(payload) {
    var ref1, ref2;
    if (!$scope.sequence.errors) {
      return;
    }
    if ($scope.isSendMobileAppInviteEmailStep(payload) || $scope.isSendMobileAppInviteSmsStep(payload)) {
      if ((ref1 = $scope.sequence.errors['sequence_steps.sequence_payloads.body']) != null ? ref1[0] : void 0) {
        return (ref2 = $scope.sequence.errors['sequence_steps.sequence_payloads.body']) != null ? ref2[0] : void 0;
      }
    }
  };
  $scope.isFreeTrialRemindMessageAvailable = gym.on_trial_period && gym.trialling_highest_plan;
  return $scope.plan = 'Established';
}]);
